export function statusComponent({ title, subtitle, avatar, moment, icon, author }) {
	return `
	<div class="statusbar-content-item">
		<div class="statusbar-date">
			${moment.fromNow()}
		</div>
		${avatar ? 
		`<div class="statusbar-avatar">
				<img src="${avatar}" alt="" />
			</div>`
		: ''}
		${icon ? 
		`<div class="statusbar-avatar-icon">
				<span class="icon icon-${icon}" />
			</div>`
		: ''}
		<div class="statusbar-title">
			<span>${title}</span>
			${subtitle ?
		`<span class="statusbar-subtitle">${subtitle}</span>`
		: ''}

			${author ?
		`<span class="statusbar-author">${Screen.trans('by')} ${author}</span>`
		: ''}
		</div>
	</div>`;
}

export function announcementNotification({ title, icon, author }) {
	return `
	<div class="notification-announcement">
		${icon ? 
		`<h1 class="notification-announcement-icon"><span class="icon icon-${icon}" /></h1>`
		: ''}
		<h1 class="notification-announcement-text">${title}</h1>
		${author 
		? `<h4 class="notification-announcement-author">${Screen.trans('Announcement by')} ${author}</h4>` : ''}
		
	</div>`;
}

export function getStatusBarClass(announcementType) {
	return `statusbar-announcement-${announcementType}`;
}
